import type { SvgIconProps } from 'types/icon';
import Check from '@mui/icons-material/Check';

export const CheckIcon = ({ color = 'inherit', ...props }: SvgIconProps) => (
  <Check color={color} {...props} />
);
